/// <reference types="vite-plugin-svgr/client" />
import { NavLink } from 'react-router-dom';
import EducationIcon from 'assets/icons/education.svg?react';
import UserAdministrationIcon from 'assets/icons/user-administration.svg?react';
import styles from './ServiceLinks.module.scss';
import { useAuth } from 'hooks/useAuth';
import { PartnerPermission } from 'typescript-partner-client';
import { useTranslation } from 'react-i18next';
import ProfileCard from 'components/ProfileCard';
import { AUSCULTATION_ONBOARDING_STATUS } from '../../../../constants';
import useBmsVersion from '~/pages/BMSLabelling/useBmsVersion';

export default function ServiceLinks() {
  const { t } = useTranslation();
  const { session } = useAuth();
  const { data } = useBmsVersion();

  return (
    <div className={styles.wrapper}>
      <header>
        <ProfileCard
          user={session?.user}
          verified={session?.user?.properties?.auscultationOnboarding === AUSCULTATION_ONBOARDING_STATUS.ACCEPTED}
        />
      </header>
      <div className={styles.linksWrapper}>
        <ServiceLink path="/administration" icon={<UserAdministrationIcon />} supervisor>
          {t('page.dashboard.links.administration')}
        </ServiceLink>
        <ServiceLink
          path="https://blodtrycksdoktorn.se/hur-du-l%c3%a4gger-till-anv%c3%a4ndare-i-partnerportalen/"
          icon={<EducationIcon />}
          supervisor
        >
          {t('page.dashboard.links.administration_education')}
        </ServiceLink>
        {data?.version && (
          <ServiceLink path="/om/bms" icon={<EducationIcon />}>
            {t('page.dashboard.links.about')}
          </ServiceLink>
        )}
      </div>
    </div>
  );
}

const ServiceLink = ({ children, icon, path, supervisor = false }) => {
  const { authorities } = useAuth();
  const { t } = useTranslation();

  if (supervisor && !authorities.includes(PartnerPermission.USER_ADMIN)) {
    return null;
  }

  const content = (
    <>
      <div className="flex align-center">
        <span className={styles.linkIcon}>{icon}</span> {children}
      </div>
      {supervisor && <span className={styles.badge}>{t('page.dashboard.supervisor_badge')}</span>}
    </>
  );

  return (
    <div className={styles.link}>
      {path.startsWith('http') ? (
        <a href={path} target="_blank" rel="noreferrer noopener">
          {content}
        </a>
      ) : (
        <NavLink to={path}>{content}</NavLink>
      )}
    </div>
  );
};
